import React, { useEffect } from 'react';
import { resetOfferAndNotify } from 'helpers/resetOfferAndNotify';
import { useDispatch } from 'react-redux';
import HeaderContainer from '../../containers/header';
import FooterContainer from '../../containers/footer';
import WinnersLanding from '../../containers/winners/winnersLanding';

const WinnersPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    resetOfferAndNotify(dispatch);
  }, []);

  return (
    <>
      <HeaderContainer />
      <WinnersLanding />
      <FooterContainer />
    </>
  );
};

export default WinnersPage;
